import React from 'react'
import AddPromotionListItemForm from './AddPromotionListItemForm'

class AddPromotionListItem extends React.Component {
  render() {
    return <AddPromotionListItemForm {...this.props} />
  }
}

export default AddPromotionListItem



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/AddPromotionListItem.js